document.addEventListener('DOMContentLoaded', () => {
  const img = document.querySelector('.cert-hero .cert-hero__img');
  if (!img) return;

  // Keep whatever base transform Liquid/CSS applied
  const base = getComputedStyle(img).getPropertyValue('transform');

  const onMove = e => {
    const r = img.getBoundingClientRect();
    const x = (e.clientX - r.left) / r.width - 0.5;
    const y = (e.clientY - r.top) / r.height - 0.5;
    const rx = -(y * 6).toFixed(2);
    const ry = (x * 6).toFixed(2);
    img.style.transform = `${base === 'none' ? '' : base} rotateX(${rx}deg) rotateY(${ry}deg)`;
  };

  const reset = () => { img.style.transform = base; };

  img.addEventListener('mousemove', onMove);
  img.addEventListener('mouseleave', reset);
});
